import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSite } from '../data/SiteContext';

export default function Tours() {
  const navigate = useNavigate();
  const { tours } = useSite();
  return (
    <div className="wrap" style={{ paddingTop:40, paddingBottom:72 }}>
      <div className="kicker">Experiences</div>
      <h1 className="page-h1">Tours & excursions</h1>
      <p className="page-sub">Hand-picked day trips and private guides — add any of these to your package.</p>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(290px,1fr))', gap:22 }}>
        {tours.map(t => (
          <div key={t.id} className="card lift" onClick={() => navigate('/tours/' + t.id)}
            style={{ cursor:'pointer', borderRadius:22, overflow:'hidden', display:'flex', flexDirection:'column', boxShadow:'0 12px 28px rgba(16,90,90,0.1)' }}>
            <div style={{ height:190 }}><div className="bgimg" style={{ backgroundImage:`url(${t.img})` }}></div></div>
            <div style={{ padding:20, display:'flex', flexDirection:'column', flex:1 }}>
              <div style={{ fontSize:12, fontWeight:700, color:'#0e9c86', textTransform:'uppercase', letterSpacing:'.05em' }}>{t.place} · {t.dur}</div>
              <div className="serif" style={{ fontSize:22, margin:'6px 0 10px', lineHeight:1.15 }}>{t.name}</div>
              <div style={{ fontSize:14, color:'#5a726f', lineHeight:1.55, marginBottom:14, flex:1 }}>{t.desc}</div>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <span style={{ fontWeight:800 }}>{t.price ? `$${t.price}` : 'price on request'}{t.price ? <span style={{ fontWeight:600, color:'#5a726f', fontSize:13 }}> / person</span> : null}</span>
                <span style={{ fontSize:13, fontWeight:700, color:'#0e8a9c' }}>Details →</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function TourDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { tours, dests, loading, contact } = useSite();
  const t = tours.find(x => String(x.id) === id);

  if (!t) {
    return (
      <div className="wrap" style={{ paddingTop:80, paddingBottom:120, textAlign:'center', color:'#5a726f' }}>
        {loading ? 'Loading…' : <>We couldn't find that tour. <Link to="/tours" style={{ color:'#0e8a9c', fontWeight:700 }}>See all tours</Link></>}
      </div>
    );
  }

  // A tour names its place as free text; where that matches a destination we can link the two.
  const destination = dests.find(d => d.name?.toLowerCase() === (t.place || '').toLowerCase());
  const others = tours.filter(x => x.id !== t.id).slice(0, 3);
  const enquiry = `${contact.waLink}?text=${encodeURIComponent(`Hi! I'd like to book the ${t.name}${t.place ? ` in ${t.place}` : ''}.`)}`;

  return (
    <div>
      <section style={{ position:'relative', minHeight:'clamp(320px,45vh,450px)', display:'flex', alignItems:'flex-end', overflow:'hidden' }}>
        <div className="cover"><div className="bgimg" style={{ backgroundImage:`url(${t.img})` }}></div></div>
        <div className="cover" style={{ background:'linear-gradient(180deg,rgba(6,40,45,0.15),rgba(6,40,45,0.75))' }}></div>
        <div style={{ position:'relative', maxWidth:1240, margin:'0 auto', padding:'0 24px 40px', width:'100%', color:'#fff' }}>
          <span onClick={() => navigate('/tours')} style={{ cursor:'pointer', color:'rgba(255,255,255,0.9)', fontWeight:700, fontSize:14 }}>← All tours</span>
          <div style={{ display:'inline-block', margin:'14px 0 8px', padding:'6px 14px', borderRadius:100, background:'rgba(255,255,255,0.2)', border:'1px solid rgba(255,255,255,0.4)', fontSize:12.5, fontWeight:700 }}>
            {[t.place, t.dur].filter(Boolean).join(' · ')}
          </div>
          <h1 className="serif" style={{ fontSize:'clamp(30px,5vw,54px)', margin:0, letterSpacing:'-0.5px', lineHeight:1.1 }}>{t.name}</h1>
        </div>
      </section>

      <div style={{ maxWidth:1240, margin:'0 auto', padding:'40px 24px 72px', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:40 }}>
        <div>
          <h2 className="serif" style={{ fontSize:28, margin:'0 0 12px' }}>About this trip</h2>
          <p style={{ fontSize:16.5, lineHeight:1.7, color:'#0c2b2f', whiteSpace:'pre-line' }}>{t.desc}</p>

          <h3 className="serif" style={{ fontSize:22, margin:'30px 0 14px' }}>Good to know</h3>
          <div style={{ display:'grid', gap:10 }}>
            {[
              ['Departures', 'Daily, subject to weather and minimum numbers. We confirm your date at the time of booking.'],
              ['Transfers', 'Hotel pick-up and drop-off are arranged for you — tell us where you are staying.'],
              ['Group size', 'Shared and private options are both available; private costs more and moves at your pace.'],
              ['Payment', 'Nothing is charged until the date is confirmed.'],
            ].map(([k, v]) => (
              <div key={k} className="card" style={{ padding:'15px 18px', borderRadius:14 }}>
                <div style={{ fontSize:11.5, fontWeight:800, color:'#5a726f', textTransform:'uppercase', letterSpacing:'.06em' }}>{k}</div>
                <div style={{ fontSize:14.5, marginTop:4, lineHeight:1.55 }}>{v}</div>
              </div>
            ))}
          </div>

          {others.length > 0 && (
            <>
              <h3 className="serif" style={{ fontSize:22, margin:'34px 0 14px' }}>Other excursions</h3>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:14 }}>
                {others.map(o => (
                  <Link key={o.id} to={'/tours/' + o.id} className="card lift" style={{ display:'block', borderRadius:16, overflow:'hidden', color:'inherit' }}>
                    <div style={{ height:100 }}><div className="bgimg" style={{ backgroundImage:`url(${o.img})` }}></div></div>
                    <div style={{ padding:12 }}>
                      <div style={{ fontWeight:700, fontSize:14, lineHeight:1.3 }}>{o.name}</div>
                      <div style={{ fontSize:12.5, color:'#5a726f', marginTop:3 }}>{o.price ? `$${o.price} / person` : 'price on request'}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>

        <div>
          <div className="card" style={{ position:'sticky', top:100, padding:26, borderRadius:24, boxShadow:'0 16px 40px rgba(16,90,90,0.14)' }}>
            <div style={{ fontSize:13, color:'#5a726f', fontWeight:600 }}>Price</div>
            <div className="serif" style={{ fontSize: t.price ? 44 : 26, color:'#0e8a9c', lineHeight:1.2, margin:'2px 0 2px' }}>{t.price ? `$${t.price}` : 'Price on request'}</div>
            <div style={{ fontSize:13, color:'#5a726f', marginBottom:18 }}>per person{t.dur ? ` · ${t.dur}` : ''}</div>

            {destination && (
              <Link to={'/destinations/' + destination.slug} style={{ display:'block', marginBottom:14, fontSize:13.5, fontWeight:700, color:'#0e8a9c' }}>
                Part of our {destination.name} trips →
              </Link>
            )}

            <a href={enquiry} target="_blank" rel="noreferrer" className="btn btn-green" style={{ display:'block', padding:15, boxShadow:'0 10px 22px rgba(18,153,76,0.35)' }}>Book on WhatsApp</a>
            <a href={contact.telLink} style={{ display:'block', textAlign:'center', marginTop:10, padding:13, borderRadius:14, fontWeight:700, color:'#0e8a9c', background:'rgba(14,138,122,0.1)' }}>Or call {contact.phone}</a>
          </div>
        </div>
      </div>
    </div>
  );
}
